import { ApiPageType } from "@incendium/api";
import {
  Button,
  IconButton,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import Delete from "@mui/icons-material/Delete";
import SpacedList, { SpacedLinkButton } from "Components/UI/SpacedList";
import { cell2Icons } from "consts";
import Edit from "@mui/icons-material/Edit";

interface IPageTypesListProps {
  pageTypes: ApiPageType[];
  onEdit: (pageType: ApiPageType) => void;
  onDelete: (pageType: ApiPageType) => void;
  onNew: () => void;
}

function PageTypesList({
  pageTypes,
  onEdit,
  onDelete,
  onNew,
}: IPageTypesListProps) {
  return (
    <SpacedList action={<Button onClick={onNew}>New Location Tag</Button>}>
      <TableHead>
        <TableRow>
          <TableCell>Name</TableCell>
          <TableCell></TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {pageTypes.map((pt) => (
          <TableRow key={pt.id}>
            <TableCell>
              <SpacedLinkButton onClick={() => onEdit(pt)}>
                {pt.name || ""}
              </SpacedLinkButton>
            </TableCell>
            <TableCell align="right" style={{ width: cell2Icons }}>
              <IconButton
                size="small"
                color="primary"
                onClick={() => onEdit(pt)}
              >
                <Edit />
              </IconButton>
              <IconButton
                size="small"
                color="secondary"
                onClick={() => onDelete(pt)}
              >
                <Delete />
              </IconButton>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </SpacedList>
  );
}

export default PageTypesList;
